// Create variable for header height to allow correct sticky positioning of elements

document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('HeaderWrapper');

  if (!header) return;

  const getExtraBarHeight = () => {
    const extraBar = document.getElementById('limoniapps-discountninja-stickybar-wrapper');
    return extraBar ? extraBar.offsetHeight : 0;
  };

  const setHeightVar = () => {
    const totalHeight = header.offsetHeight + getExtraBarHeight();

    document.documentElement.style.setProperty(
      '--header-height',
      totalHeight + 'px'
    );
  };

  // Initial run
  setHeightVar();

  // Observe header
  const headerObserver = new ResizeObserver(setHeightVar);
  headerObserver.observe(header);

  // Observe extra bar (if present at load)
  const extraBar = document.getElementById('limoniapps-discountninja-stickybar-wrapper');
  if (extraBar) {
    const barObserver = new ResizeObserver(setHeightVar);
    barObserver.observe(extraBar);
  }

  // Watch for the bar being injected later
  const bodyObserver = new MutationObserver(() => {
    const extraBar = document.getElementById('limoniapps-discountninja-stickybar-wrapper');
    if (extraBar) {
      setHeightVar();

      const barObserver = new ResizeObserver(setHeightVar);
      barObserver.observe(extraBar);

      bodyObserver.disconnect();
    }
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});